var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-container" },
    [
      _vm._t(
        "default",
        function() {
          return [
            _vm.type === "s"
              ? _c(
                  "Select",
                  _vm._b(
                    {
                      attrs: { value: _vm.tempVal },
                      on: { "on-change": _vm.changeValue }
                    },
                    "Select",
                    _vm.$attrs,
                    false
                  ),
                  _vm._l(_vm.dataList || _vm.originList, function(item) {
                    return _c(
                      "Option",
                      { key: item.id, attrs: { value: item[_vm.valueAttr] } },
                      [_vm._v(" " + _vm._s(item[_vm.labelAttr]) + " ")]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm.type === "d"
              ? _c(
                  "Dropdown",
                  _vm._b(
                    { on: { "on-click": _vm.changeValue } },
                    "Dropdown",
                    _vm.$attrs,
                    false
                  ),
                  [
                    _vm._t("dropdown-slot", function() {
                      return [
                        _c(
                          "Button",
                          { attrs: { type: "primary" } },
                          [
                            _vm._v(" " + _vm._s(_vm.tempVal) + " "),
                            _c("Icon", { attrs: { type: "ios-arrow-down" } })
                          ],
                          1
                        )
                      ]
                    }),
                    _c(
                      "DropdownMenu",
                      { attrs: { slot: "list" }, slot: "list" },
                      _vm._l(_vm.dataList || _vm.originList, function(item) {
                        return _c(
                          "DropdownItem",
                          {
                            key: item.id,
                            attrs: {
                              name: _vm.itemitem[_vm.valueAttr],
                              selected: _vm.tempVal === item[_vm.valueAttr]
                            }
                          },
                          [_vm._v(_vm._s(item[_vm.labelAttr]))]
                        )
                      }),
                      1
                    )
                  ],
                  2
                )
              : _vm._e()
          ]
        },
        { dataList: _vm.dataList || _vm.originList }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }